export default "__VITE_ASSET__DKaQC8Wh__"